function initEllipsis() {
    Ellipsis({
        class: '[data-mcube-ellipsis]',
        lines: 3
    });
    Ellipsis({
        class: '[data-mcube-ellipsis-title]',
        lines: 1
    });
}
